import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAQK4_VktMqOlGPNMHW9aZIoGd0MQTxMXE",
  authDomain: "my-book-list-4276d.firebaseapp.com",
  projectId: "my-book-list-4276d",
  storageBucket: "my-book-list-4276d.appspot.com",
  messagingSenderId: "938805892455",
  appId: "1:938805892455:web:49ac2802a959b932cacbc2",
};

// init firebase
initializeApp(firebaseConfig);

// init services
const db = getFirestore();
const auth = getAuth();

export { db, auth };
